import * as Yup from 'yup';
import { SarlaftComplaints } from '../../../../../../shared/types/modules/sarlaft';

export const initialValues: SarlaftComplaints = {
    dateComplaint: '',
    bouquet: '',
    company: '',
    value: '',
    complaint: '',
    compensation: '',
};

export const validationSchema = Yup.object({
    dateComplaint: Yup.string().required('La fecha de reclamo es obligatoria'),
    bouquet: Yup.string().required('El ramo es obligatorio'),
    company: Yup.string().required('La compañia es obligatoria'),
    value: Yup.string().required('El valor es obligatiorio'),
    complaint: Yup.string().required('La reclamación es obligatioria'),
    compensation: Yup.string().required('La indemnización es obligatioria'),
});
